import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useFormContext, useWatch } from 'react-hook-form';
import useFiltersCache from '../../../hooks/useFiltersCache';
import { USFilterFields } from '../../../Interfaces/admin/User.interfaces';
import { ApprovalSequenceFilters } from './ApprovalSequenceFilters';
import { ASFilterFields } from '../../../Interfaces/admin/ApprovalSequence.interface';

const ApprovalSequenceParams = () => {
  const [cookies] = useCookies(['adminFilters']);
  const { setValue } = useFormContext<ApprovalSequenceFilters>();
  const filters = useWatch();
  useFiltersCache({
    tab: 'AS',
    filters,
    cookieName: 'adminFilters',
    path: '/admin',
  });
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    if (!rendered && cookies.adminFilters?.tab === 'AS') {
      setRendered(true);
      const cookieFilters = cookies.adminFilters?.filters;

      for (const i in cookieFilters) {
        setValue(i as ASFilterFields, cookieFilters[i]);
      }
    }
  }, [setValue, rendered, setRendered, cookies.adminFilters]);

  return <span />;
};

export default ApprovalSequenceParams;
